import React, { useEffect, useState } from 'react';
import Layout from '../../../components/Layout/Layout';
import LCDashboard from '../../../components/Data/Dashboard/LCDashboard';
import LcLoading from '../../../components/Generic/LcLoading';
import LcNoData from '../../../components/Generic/LcNoData';
import IconValue from '../../../components/Layout/Dashboard/IconValue';
import { RiBarChart2Line } from 'react-icons/ri';
import { TbCalendarDollar, TbPigMoney } from 'react-icons/tb';
import LcInfiniteTable from '../../../components/Data/LcInfiniteTable';
import { FinOpsSavingPlanReserveService } from '../../../services/finOps/FinOpsSavingPlanReserve/FinOpsSavingPlanReserve';
import { Resouces, SavingPlanReserveModel } from '../../../services/finOps/FinOpsSavingPlanReserve/FinOpsSavingPlanReserveModel';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { UserState } from '../../../store/reducers/userReducer';
import moment from 'moment';
import { SiMicrosoftazure } from 'react-icons/si';
import { FaAws } from "react-icons/fa";
import { PPModal } from 'processor-plataform-ui';
import LcIconLink from '../../../components/Generic/LcIconLink';
import { MdOutlineInfo } from 'react-icons/md';
import MediaUsageChart from './MediaUsageChart';
import PPDropDown from '../../../components/PPDropDown';
import UsedVsNotUsedChart from './UsedVsNotUsedChart';
import './index.css'

const FinopsSavingPlanAndReserveResume: React.FC = (props) => {
    const user = useSelector<RootState, UserState>(state => state.user);
    const savingPlanReserveService = new FinOpsSavingPlanReserveService(props) 
    const [loading, setLoading] = useState<boolean>(false);
    const [savingPlanReserveData, setSavingPlanReserveData] = useState<SavingPlanReserveModel[]>([])
    const [openModal, setOpenModal] = useState<boolean>(false);
    const [savaingPlanReserveDetails, setSavaingPlanReserveDetails] = useState<SavingPlanReserveModel>();
    const [possibleSavings, setPossibleSavings] = useState<string>('0')
    const [totalSavingPlans, setTotalSavingPlans] = useState<number>(0)
    const [totalReservas, setTotalReservas] = useState<number>(0)
    const [mediaMonthOpt, setMediaMonthOpt] = useState([{label: 'Este mês', value: 1}, {label: 'Mês anterior', value: 2}, {label: 'Todo período', value: 3}])
    const [mediaSelected, setMediaSelected] = useState<number>(1)

    const getSavingPlanReserve = async () => {
        try {
            let sarvingPlanReserveResponse = await savingPlanReserveService.getSavingPlanReserve();
            setSavingPlanReserveData(sarvingPlanReserveResponse);
            setPossibleSavings(sarvingPlanReserveResponse.reduce((somatorio, objeto) => somatorio + objeto.possible_savings, 0).toLocaleString("pt-br", {style:"currency", currency:"BRL"}))
            setTotalSavingPlans( sarvingPlanReserveResponse.filter(objeto => objeto.type.toLowerCase() === "saving plan").length);
            setTotalReservas(sarvingPlanReserveResponse.filter(objeto => objeto.type.toLowerCase() === "reserva").length);

        } catch (error) {
            console.error(`Error: ${error}`);
        }
    }

    useEffect(() => {
        setLoading(true);
        getSavingPlanReserve().finally(() => setLoading(false));
    },[user.ClientGroupSelected, user.refreshFlag])


    const labelStatusToExpired = (status: Date) => {
        let expiredDate = new Date(status)
        const dataAtual = new Date();
        const dataLimite30Dias = new Date();
        dataLimite30Dias.setDate(dataAtual.getDate() + 31);
      
        if (expiredDate < dataAtual) {
          return "Expirado"; 
        } else if (expiredDate <= dataLimite30Dias) {
          return "Expirando"; 
        } else {
          return "Ativo";
        }
      }

      function colorStatusToExpired(data: SavingPlanReserveModel) {
        let expiredDate = new Date(data.expired_date)
        const dataAtual = new Date();
        const dataLimite30Dias = new Date();
        dataLimite30Dias.setDate(dataAtual.getDate() + 31);
      
        if (expiredDate < dataAtual) {
          return "#dc291e"; 
        } else if (expiredDate <= dataLimite30Dias) {
          return "#ffa400";
        } else {
          return "#3ebb3f"; 
        }
      }
      const tranleteStatusColor = (status: Resouces) => {
        const tranlateStatusColor = {
          'important':'#ffa400', 
          'critical': "#dc291e",
          'moderate': "#f6de00",
          'low': "#3ebb3f",
          'unclassified': "#cccccf",
        };
        return tranlateStatusColor[status.resouce_status];
      }

    const columns = [
        { field: "plan", headerName: "Provedor/Plano", width: "25%", align: 'left', renderCell: (row: SavingPlanReserveModel) => {
            return (
                <div className="row ml-2">
                    {row.provider === 'Azure' ? <SiMicrosoftazure /> : <FaAws />}
                    <span style={{color: '#00aee1', fontWeight: 600, cursor: 'pointer'}} onClick={() => {setOpenModal(true); setSavaingPlanReserveDetails(row); }} className='font-4x'>{row.plan}</span>
                </div>
            )
        }},
        { field: "type", headerName: "Tipo", width: "10%", align: 'left',},
        { field: "alocation", headerName: "Alocação", width: "12%", align: 'left',hide: false},
        { field: "service", headerName: "Serviço", width: "10%", align: 'left'},
        { field: "scope", headerName: "Escopo", width: "16%", align: 'left', 
            renderCell: (row: SavingPlanReserveModel) => <div className='overflowEllipsis'>{row.scope}</div>    
        },
        { field: "region", headerName: "Região", width: "12%", align: 'left'},
        { field: "commitment", headerName: "Compromisso", width: "10%", align: 'center'},
        { field: "monthly_cost", headerName: "Custo Mensal (R$)", width: "18%", align: 'right', 
            renderCell: (row: SavingPlanReserveModel) => row.monthly_cost.toLocaleString("pt-br", {style:"currency", currency:"BRL"})
        },
        { field: "possible_savings", headerName: "Possível economia (R$)", width: "20%", align: 'right', 
            renderCell: (row: SavingPlanReserveModel) => row.possible_savings.toLocaleString("pt-br", {style:"currency", currency:"BRL"})
        },
        { field: "use", headerName: "Utilização", width: "10%", align: 'center', renderCell:(row: SavingPlanReserveModel) => `${(row.use * 100)}%`  },
        { field: "expired_date", headerName: "Expira em", width: "10%", align: 'left', 
            renderCell:(row: SavingPlanReserveModel) => moment(row.expired_date).format('DD/MM/YYYY')  
        },
    ]

    const collumnsDetails = [
        { field: "subscrition", headerName: "Subscrição", width: "35%", align: 'left',},
        { field: "resource_group", headerName: "Grupo de recursos", width: "18%", align: 'left',},
        { field: "resource_name", headerName: "Nome do recurso", width: "18%", align: 'left',},
        { field: "product", headerName: "Produto", width: "12%", align: 'left',},
        { field: "quantity_used", headerName: "Quantidade usada", width: "15%", align: 'center',},
    ]

    const cards = [
      {
        id: 1, //saving plan
        type: 'Custom', position: { ColSpan: 3, RowSpan: 1, row: 1, col: 1 },
        showFocusButton: false,
        title: () => "Saving plans",
        customContentRender: () => {
            return (
                <LcLoading loading={loading} label="Carregando saving plans...">
                    {
                        totalSavingPlans ?
                            <>
                                <IconValue
                                    value={totalSavingPlans}
                                    color="#141b4d"
                                    icon={<RiBarChart2Line />}
                                    description='ativos em seu ambiente cloud'
                                    cssClass='font-xl'
                                />
                            </>
                            :
                            <LcNoData size="small" />
                    }
                </LcLoading>

            )
        }
    },
      {
        id: 2, //Reservas de instâncias"
        type: 'Custom', position: { ColSpan: 3, RowSpan: 1, row: 1, col: 4 },
        showFocusButton: false,
        title: () => "Reservas de instâncias",
        customContentRender: () => {
            return (
                <LcLoading loading={loading} label="Carregando reservas de instâncias...">
                    {
                        totalReservas ?
                            <>
                                <IconValue
                                    value={totalReservas}
                                    color="#141b4d"
                                    icon={<TbCalendarDollar />}
                                    description='ativos em seu ambiente cloud'
                                    cssClass='font-xl'
                                />
                            </>
                            :
                            <LcNoData size="small" />
                    }
                </LcLoading>

            )
        }
    },
      {
        id: 3, //Possível economia mensal 
        type: 'Custom', position: { ColSpan: 3, RowSpan: 1, row: 1, col: 7 },
        showFocusButton: false,
        title: () => "Possível economia mensal ",
        infoContent:() => "Possivel economia com saving plans e reservas feitas",
        customContentRender: () => {
            return (
                <LcLoading loading={loading} label="Carregando possível economia mensal...">
                    {
                        possibleSavings ?
                            <>
                                <IconValue
                                    value={possibleSavings}
                                    color="#3ebb3f"
                                    icon={<TbPigMoney />}
                                    description='com o uso de saving plans e reservas'
                                    cssClass='font-xl'
                                />
                            </>
                            :
                            <LcNoData size="small" />
                    }
                </LcLoading>

            )
        }
    },
      {
        id: 4, //Média de utilização (%) "
        type: 'Custom', position: { ColSpan: 3, RowSpan: 1, row: 1, col: 10 },
        showFocusButton: false,
        title: () =>  {
            return <>
                {
                    <div className={'lc-segment-title-row-resume'} style={{alignItems: 'flex-end'}}>
                        <div className={'lc-title ellipsis'}>Média de utilização (%) </div>
                        <PPDropDown
                            options={mediaMonthOpt}
                            defaultValue={mediaMonthOpt.find(option => option.value == mediaSelected)}
                            value={mediaMonthOpt.find(option => option.value == mediaSelected)}
                            onChange={(event) => setMediaSelected(event.value)}
                            width='112px'
                        />
                    </div>
                }</>
        },
        customContentRender: () => {
            return <MediaUsageChart data={savingPlanReserveData} loading={loading} periodSelected={mediaSelected} />
        }
    },
      {
        id: 5, //List"
        type: 'Custom', position: { ColSpan: 12, RowSpan: 3, row: 2, col: 1 },
        showFocusButton: false,
        title: () => "",
        customContentRender: () => {
            return (
                <LcLoading loading={loading} label="Carregando saving plans...">
                    {
                        savingPlanReserveData ?
                            <>
                             <LcInfiniteTable rows={savingPlanReserveData} 
                                columns={columns} 
                                loadMore={() => undefined}
                                size={savingPlanReserveData.length}
                                hidePagination
                                fontSize='small'
                                status={colorStatusToExpired}
                              />
                            </>
                            :
                            <LcNoData size="small" />
                    }
                </LcLoading>

            )
        }
    },
  ]


  return (
    <Layout pageTitle='Savings/Reservas'>
        <LCDashboard
            cards={cards} 
        />
        
        <PPModal title={"Detalhes do plano"} size='large' visible={openModal} onClose={() => setOpenModal(false)} >
        {
          savaingPlanReserveDetails &&
            <div className='detailsPlan'>
                <div className="headerPlanDetails">
                <div className='detailSavingPlanOrReserve'>
                    <section className="inicialInfo">
                        <div className='detailsName'>
                            <div className='row'>
                                <h4>{savaingPlanReserveDetails.plan}</h4>
                                <div className='bagdeStatusPlan' style={{backgroundColor: colorStatusToExpired(savaingPlanReserveDetails)}}>
                                    {labelStatusToExpired(savaingPlanReserveDetails.expired_date)}
                                </div>
                            </div>
                            <div className='mt-3'>
                                {savaingPlanReserveDetails.provider === 'Azure' ? <SiMicrosoftazure /> : <FaAws />}
                                <span className='ml-4 font-4x'>{savaingPlanReserveDetails.plan}</span>
                            </div> 
                        </div>
                        <div className='possible_savings'>
                            <span className="labelGray">Possível economia mensal:</span>
                            <p>{savaingPlanReserveDetails.possible_savings.toLocaleString("pt-br", {style:"currency", currency:"BRL"})}</p>
                        </div>
                    </section>
                    <section className="useDetails">
                        <div className='percente'>
                            <h6 className='mr-5'>Utilização:</h6> 
                            <div className='totalPercente'>
                                <p>{((savaingPlanReserveDetails.used / savaingPlanReserveDetails.reservations) * 100).toFixed(0)} %</p> 
                                <div style={{ width:`${((savaingPlanReserveDetails.used / savaingPlanReserveDetails.reservations) * 100).toFixed(0)}%` }} className='usePercente'></div> 
                            </div>
                        </div>
                        <div className='usedAndReservedInfo'>
                            <p><span className="labelGray mr-2">Reservadas:</span> {savaingPlanReserveDetails.reservations} horas</p>
                            <p ><span className="labelGray mr-2">Usadas:</span> {savaingPlanReserveDetails.used} horas</p>
                        </div>
                    </section>
                    <section className="restDetails">
                        <div className='rowPlanDetails'>
                            <div className='row'>
                                <span className="labelGray" >Custo Mensal:</span>
                                <p>{savaingPlanReserveDetails.monthly_cost.toLocaleString("pt-br", {style:"currency", currency:"BRL"})}  </p>
                                <p style={{color: '#eb8a8c', fontSize: '11px', fontStyle: 'italic'}}>({(savaingPlanReserveDetails.monthly_cost + savaingPlanReserveDetails.possible_savings).toLocaleString("pt-br", {style:"currency", currency:"BRL"})})</p>
                                <LcIconLink tooltip={`Valor sem a ${savaingPlanReserveDetails.type}`} tooltipPosition='inline-right' icon={<MdOutlineInfo size={16} />} size='small' />
                            </div>
                            <div className='row'>
                                <span className="labelGray" >Escope:</span>
                                <p>{savaingPlanReserveDetails.scope}</p>
                            </div>
                        </div>
                        <div className='rowPlanDetails'>
                            <div className='divDetails'>
                                <div className='row'>
                                    <span className="labelGray" >Pagamento:</span>
                                    <p>{savaingPlanReserveDetails.payment}  </p>
                                </div>
                                <div className='row mt-6'>
                                    <span className="labelGray" >Região:</span>
                                    <p>{savaingPlanReserveDetails.region}  </p>
                                </div>
                            </div>
                        
                            <div className='divDetails'>
                                <div className='row'>
                                    <span className="labelGray" >Flexibilidade:</span>
                                    <p>{savaingPlanReserveDetails.flexibility}</p>
                                </div>
                                <div className='row mt-6'>
                                    <span className="labelGray" >Alocação:</span>
                                    <p>{savaingPlanReserveDetails.alocation}</p>
                                </div>
                            </div>
                            <div className='divDetails'>
                                <div className='row'>
                                    <span className="labelGray" >Compromisso:</span>
                                    <p>{savaingPlanReserveDetails.commitment}</p>
                                </div>
                                <div className='row mt-6'>
                                    <span className="labelGray" >Expira em:</span>
                                    <p>{moment(savaingPlanReserveDetails.expired_date).format('DD/MM/YYYY')}</p>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <div className="graphDetails">
                    <UsedVsNotUsedChart data={savaingPlanReserveDetails}/>
                </div>

                </div>
                <div className='bodySystem'>
                    <h4>Recursos</h4>
                    <LcInfiniteTable 
                        fontSize='medium' 
                        rows={savaingPlanReserveDetails.resouces} 
                        columns={collumnsDetails} 
                        loadMore={() => undefined} 
                        size={savaingPlanReserveDetails.resouces.length} 
                        hidePagination 
                        status={tranleteStatusColor}
                        height='28vh'/>
                </div>
          </div>
        }
        </PPModal>
    </Layout>
  );
}

export default FinopsSavingPlanAndReserveResume;